import { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router';

const BlockRedirect = ({ shouldBlock, message, ignoredPaths }) => {
    const history = useHistory();
    const unblock = useRef(null);
    const [leavePromptAcknowledged, setLeavePromptAcknowledged] = useState(false);

    useEffect(() => {
        if (shouldBlock) {
            unblock.current = history.block((nextLocation) => {
                const isIgnoredPath = ignoredPaths
                    ? ignoredPaths.some(path => nextLocation.pathname === path || nextLocation.pathname.startsWith(`${path}/`))
                    : false;
                if (isIgnoredPath) {
                    return true;
                }
                if (!leavePromptAcknowledged) {
                    if (window.confirm(message)) {
                        setLeavePromptAcknowledged(false);
                        unblock.current();
                        return true;
                    } else {
                        setLeavePromptAcknowledged(false);
                        return false;
                    }
                }
                return true;
            });
        } else {
            if (unblock.current) {
                unblock.current();
            }
        }
        return () => {
            if (unblock.current) {
                unblock.current();
            }
        };
    }, [shouldBlock, leavePromptAcknowledged, message, ignoredPaths, history]);

    return null;
};

export default BlockRedirect;
